const server = 'https://kita-api.kimcuongkita.com.vn';

export const environment = {
  production: true,
  server,
  apiUrl:  `${server}/v1`,
  userPage: 'https://beta.kimcuongkita.com.vn/',
  maxFileSize: 100,
};
